import React, { forwardRef, memo } from 'react';
import { useTranslation } from 'react-i18next';

import { IconButton } from '../../material-ui/IconButton';
import { MoreVertIconContrast } from '../../../icons/MoreVertIconContrast';
import { Menu, MenuItem } from '../../material-ui/Menu';
import { Typography } from '../../material-ui/Typography';
import { stopPropagation } from '../../../service/eventHandlers';
import { useAnchorEl } from '../../hooks/useAnchorEl';
import { useStyles } from './useStyles';

const MENU_ANCHOR = {
    vertical: 'bottom',
    horizontal: 'center',
};
const MENU_TRANSFORM = {
    vertical: 'top',
    horizontal: 'center',
};

export const LibraryItemMenu = memo(
    forwardRef(({ onDownload, onRemove }, ref) => {
        const [anchorEl, handleOpenMenu, handleClose] = useAnchorEl();
        const classes = useStyles();
        const { t: translate } = useTranslation();
        const handleDownload = React.useCallback((evt) => {
            stopPropagation(evt);
            onDownload();
            handleClose();
        }, []);

        const handleRemove = React.useCallback((evt) => {
            stopPropagation(evt);
            onRemove();
            handleClose();
        }, []);

        return (
            <span ref={ref}>
                <IconButton className={classes.icon} onClick={handleOpenMenu}>
                    <MoreVertIconContrast />
                </IconButton>
                <Menu
                    id="simple-menu"
                    anchorEl={anchorEl}
                    open={Boolean(anchorEl)}
                    onClose={handleClose}
                    getContentAnchorEl={null}
                    anchorOrigin={MENU_ANCHOR}
                    transformOrigin={MENU_TRANSFORM}
                >
                    <MenuItem className={classes.menuList} onClick={handleDownload}>
                        <Typography>{translate('download')}</Typography>
                    </MenuItem>
                    <MenuItem className={classes.menuList} onClick={handleRemove}>
                        <Typography>{translate('remove')}</Typography>
                    </MenuItem>
                </Menu>
            </span>
        );
    })
);
